import ApiServiceV2 from 'services/apiService/apiServiceV2';

const endpoint = orderId =>
	`/orders/v1/${encodeURIComponent(orderId)}/no-pay-restriction`;

export const getNoPayRestriction = orderId =>
	ApiServiceV2.get({ url: endpoint(orderId) });

export const updateNoPayRestriction = (orderId, payload) =>
	ApiServiceV2.patch({
		url: endpoint(orderId),
		data: payload,
	});
